// A lead's roles are stored as { platform, role } pairs, and the same pair can appear more than once
// (approved + non-approved). Both the lead board cards and the Lead Details card show the same
// human-readable list, so the mapping lives here instead of being repeated per screen.
export const leadRoleLabel = (r) => {
	if (r?.platform === 'MARKETPLACE' && r?.role === 'BUYER') return 'Buyer'
	if (r?.platform === 'MARKETPLACE' && r?.role === 'SUPPLIER') return 'Supplier'
	if (r?.platform === 'LOGISTICS') return 'Logistics'
	return null
}

export const getLeadRoleLabels = (roles) => [...new Set((roles ?? []).map(leadRoleLabel).filter(Boolean))]

export const getLeadRolesText = (roles) => getLeadRoleLabels(roles).join(', ')
